import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { setCircularLoading } from "../../../reducers/UiReducer";
import { getService } from "../../../reducers/service";
import { notify } from "../../../reducers/NotifierReducer";
import { serviceNames } from "../../../utils/constants";
import { PATH_TRAINING_COURSES } from "../../../utils/routeConstants";
import {
  formatToTwoDecimals,
  mapDictionaryOptions,
} from "../../../utils/functions";

export const useCourseData = (id, reset) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loaded, setLoaded] = useState(false);
  const userAgency = useSelector((state) => state.user.userAgency);
  const [locationOptions, setLocationOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const dictionary = useSelector((state) => state.dictionary.dictionary);
  const tagTypeOptions = mapDictionaryOptions(dictionary.codePerTagTypes);
  useEffect(() => {
    let isMounted = true;

    const init = async () => {
      try {
        dispatch(setCircularLoading(true));
        setLoaded(false);
        const distinctService = getService(serviceNames.trainingCourseDistinct);
        const locationResponse = await distinctService.find({
          query: { column: ["location", "category"], agencyId: userAgency },
        });
        setLocationOptions(locationResponse.location);
        setCategoryOptions(locationResponse.category);

        if (id) {
          const service = getService(serviceNames.trainingCourse);

          const result = await service.get(id);
          if (isMounted && result) {
            reset({
              id: result.id || null,
              courseName: result.courseName || "",
              courseBeginDate: result.courseBeginDate
                ? moment(result.courseBeginDate).format("MM/DD/YYYY")
                : "",
              courseEndDate: result.courseEndDate
                ? moment(result.courseEndDate).format("MM/DD/YYYY")
                : "",
              location: result.location || "",
              hours: result.hours || "",
              category: result.category || "",
              approved: result.approved || false,
              courseNumber: result.courseNumber || "",
              instructor: result.instructor || "",
              certification: result.certification || "",
              expireDate: result.expireDate
                ? moment(result.expireDate).format("MM/DD/YYYY")
                : "",
              certificationEntered: result.certificationEntered || false,
              tuitionDefault:
                result.tuitionDefault === "" || result.tuitionDefault == null
                  ? null
                  : formatToTwoDecimals(result.tuitionDefault),
            });
          }
        }
      } catch (error) {
        console.error(error);
        if (isMounted) {
          dispatch(notify("Failed to fetch training course", "error"));
          history.push(PATH_TRAINING_COURSES);
        }
      } finally {
        dispatch(setCircularLoading(false));
        setLoaded(true);
      }
    };

    init();
    return () => {
      isMounted = false;
    };
  }, [id, dispatch, reset, userAgency]);

  return {
    loaded,
    locationOptions,
    categoryOptions,
    tagTypeOptions,
  };
};
